import React, { useEffect, useState, useContext } from 'react';

import axios from 'axios';
import { debounce } from 'lodash';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import AsyncSelect from 'react-select/async';
import Button from 'react-bootstrap/Button';

import { currencySymbol } from 'utils/helpers';

const ReturnItem = ({
  id,
  selectedProduct,
  selectedQuantity,
  selectedPallet,
  currencyCode,
  currency,
  callBackFunction,
  callBackFunctionDelete,
  disabled,
}) => {
  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const isDisabled = ['GM'].includes(user.role)
    ? state.ncr.status.id > 8
    : state.ncr.status.id > 1;

  const [allProducts, setAllProducts] = useState([]);
  const [product, setProduct] = useState(selectedProduct || {});
  const [quantity, setQuantity] = useState(selectedQuantity || 1);
  const [pallet_no, setPallet] = useState(selectedPallet || 1);
  const [price, setPrice] = useState(0);

  useEffect(() => {
    const priceCalc =
      (((product?.Discounted_Line_Unit_Price || 0) * quantity) / 100) *
      (100 - state.ncr.return.discount);
    setPrice(priceCalc);
    callBackFunction({ price: priceCalc });
    callBackFunction({ quantity: quantity });
    callBackFunction({ pallet_no: pallet_no });
  }, [
    product,
    quantity,
    state.ncr.return.discount,
    setPrice,
    callBackFunction,
    pallet_no,
  ]);

  /**
   * FUNCTION: handleSelect
   * This product handles the select from the dropdown search
   * @param event - contains the option, which then sets the items.
   */
  const handleSelect = (event) => {
    // returns products from existing API endpoint
    const product = allProducts.find(
      (item) => `${item.code}-${item.currency}` === event.value
    );

    // map product schema to return item schema
    const returnItem = product
      ? {
          Item: product.code,
          Description: product.description,
          Discounted_Line_Unit_Price: product.unit_price,
          CurrencyCode: product.currency,
        }
      : {};

    setProduct(returnItem);
    callBackFunction(returnItem);
  };

  /** DEPRECATED
   * 
  const setDiscount = (so) => {
    if (so) {
      let so_length = so.length;
      let sum = 0;
      so.forEach((el) => (sum += el.Line_Discount));
      const avg_discount = sum / so_length;
      setState((prev) => ({
        ...prev,
        ncr: {
          ...prev.ncr,
          return: {
            ...prev.ncr.return,
            discount: avg_discount,
          },
        },
      }));
    }
  };
   */

  /**
   * FUNCTION: calculate
   * Calculates the value of each product in accordance to the quantity sent
   * This is then set up throguh the callBackFunction to the NCRForm
   * @param value
   */
  const calculate = (value) => {
    setQuantity(value);
    callBackFunction({ quantity: value });
  };

  const calcpallet = (value) => {
    setPallet(value);
    callBackFunction({ pallet_no: value });
  };

  const debouncedFetch = debounce((input, callback) => {
    axios.get(`/api/product-view/${currencyCode}/${input}`).then((res) => {
      const options = res.data.map((product) => ({
        value: `${product.code}-${product.currency}`,
        label: product.code,
      }));
      setAllProducts(res.data);
      callback(options);
    });
  }, 1000);

  const getOptions = (input, callback) => {
    if (!input) {
      return Promise.resolve({ options: [] });
    }
    debouncedFetch(input, callback);
  };

  //returns the order item row displayed in the application
  return (
    <Row className={'mb-2'}>
      <Col xs={3}>
        {isDisabled ? (
          <FormControl value={product.Item || ''} disabled />
        ) : (
          <AsyncSelect
            loadOptions={getOptions}
            noOptionsMessage={({ inputValue }) => {
              return inputValue ? 'No options found.' : 'Type to search...';
            }}
            className="search-dropdown"
            onChange={(event) => handleSelect(event)}
            value={
              product
                ? {
                    value: `${product.Item}-${product.CurrencyCode}`,
                    label: product.Item,
                  }
                : ''
            }
          />
        )}
      </Col>
      <Col xs={3}>
        <FormControl value={product.Description || ''} disabled />
      </Col>
      <Col xs={2}>
        <FormControl
          value={quantity}
          type={'number'}
          min={1}
          step={1}
          onChange={(event) => calculate(parseInt(event.target.value))}
        />
      </Col>
      <Col xs={2}>
        <FormControl value={currencySymbol(currency, price)} disabled />
      </Col>
      <Col xs={1}>
        <FormControl
          value={pallet_no}
          type={'number'}
          min={1}
          step={1}
          onChange={(event) => calcpallet(parseInt(event.target.value))}
        />
      </Col>
      <Col xs={1}>
        <Button
          className="rounded-circle"
          variant="warning"
          id={id}
          disabled={disabled}
          onClick={(event) => {
            event.preventDefault();
            callBackFunctionDelete();
          }}
        >
          ✕
        </Button>
      </Col>
    </Row>
  );
};

export { ReturnItem };
